export default __webpack_public_path__ + "static/media/maps-logo.24b2bcb9.svg";